// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.react-modal-overlay.my-account-modal .react-modal {
  /*border: 0.1rem solid #000;*/
  color: #fff;
}
@media (min-width: 425px) {
  .react-modal-overlay.my-account-modal .react-modal {
    padding: 2rem;
    top: 10%;
    left: 0;
    right: 0;
    bottom: 10%;
  }
}
@media (min-width: 1281px) {
  .react-modal-overlay.my-account-modal .react-modal {
    padding: 0;
    top: 20%;
    left: 25%;
    right: 25%;
    bottom: 20%;
  }
}

.my-account-modal .my-account-header {
  text-transform: uppercase;
}
.my-account-modal .padding-top {
  padding-top: 2.5rem;
}
.my-account-modal .my-account-content a.faq,
.my-account-modal .my-account-content a.report,
.my-account-modal .my-account-content a.terms,
.my-account-modal .my-account-content a.privacy,
.my-account-modal .my-account-content a.delete-account,
.my-account-modal .my-account-content a.paddle-support,
.my-account-modal .my-account-content .referrals-link {
  line-height: 2.5rem;
  color: white;
  display: block;
  text-transform: uppercase;
  cursor: pointer;
}
.my-account-modal .my-account-content a.faq:hover,
.my-account-modal .my-account-content a.report:hover,
.my-account-modal .my-account-content a.terms:hover,
.my-account-modal .my-account-content a.privacy:hover,
.my-account-modal .my-account-content a.delete-account:hover,
.my-account-modal .my-account-content a.paddle-support:hover,
.my-account-modal .my-account-content .referrals-link:hover {
  text-decoration: underline;
}

.tracking-status__device, .tracking-status__global {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
}
.tracking-status__device__label, .tracking-status__global__label {
  text-transform: uppercase;
}
.tracking-status__actions {
  text-align: right;
}
.tracking-status .btn.btn-default {
  background: none;
  color: white;
  text-transform: uppercase;
  border-radius: 0;
  border: none;
  padding: 0.5rem 0;
}
.tracking-status .btn.btn-default:hover {
  text-decoration: underline;
}

.payments-and-billing a,
.referrals a {
  color: white;
  cursor: pointer;
  display: block;
}
.payments-and-billing a:hover,
.referrals a:hover {
  color: white;
}
.payments-and-billing .payments, .payments-and-billing__info, .payments-and-billing__details,
.referrals .payments,
.referrals__info,
.referrals__details {
  margin-bottom: 1.6rem;
}
.payments-and-billing .payments__current-plan, .payments-and-billing .payments__first-billing-date, .payments-and-billing .payments__next-billing-date, .payments-and-billing .payments__next-billing-amount, .payments-and-billing .payments__code, .payments-and-billing .payments__balance, .payments-and-billing .payments__user, .payments-and-billing__info__current-plan, .payments-and-billing__info__first-billing-date, .payments-and-billing__info__next-billing-date, .payments-and-billing__info__next-billing-amount, .payments-and-billing__info__code, .payments-and-billing__info__balance, .payments-and-billing__info__user, .payments-and-billing__details__current-plan, .payments-and-billing__details__first-billing-date, .payments-and-billing__details__next-billing-date, .payments-and-billing__details__next-billing-amount, .payments-and-billing__details__code, .payments-and-billing__details__balance, .payments-and-billing__details__user,
.referrals .payments__current-plan,
.referrals .payments__first-billing-date,
.referrals .payments__next-billing-date,
.referrals .payments__next-billing-amount,
.referrals .payments__code,
.referrals .payments__balance,
.referrals .payments__user,
.referrals__info__current-plan,
.referrals__info__first-billing-date,
.referrals__info__next-billing-date,
.referrals__info__next-billing-amount,
.referrals__info__code,
.referrals__info__balance,
.referrals__info__user,
.referrals__details__current-plan,
.referrals__details__first-billing-date,
.referrals__details__next-billing-date,
.referrals__details__next-billing-amount,
.referrals__details__code,
.referrals__details__balance,
.referrals__details__user {
  display: flex;
  line-height: 2.5rem;
}
.payments-and-billing .payments__current-plan__title, .payments-and-billing .payments__first-billing-date__title, .payments-and-billing .payments__next-billing-date__title, .payments-and-billing .payments__next-billing-amount__title, .payments-and-billing .payments__code__title, .payments-and-billing .payments__balance__title, .payments-and-billing .payments__user__title, .payments-and-billing__info__current-plan__title, .payments-and-billing__info__first-billing-date__title, .payments-and-billing__info__next-billing-date__title, .payments-and-billing__info__next-billing-amount__title, .payments-and-billing__info__code__title, .payments-and-billing__info__balance__title, .payments-and-billing__info__user__title, .payments-and-billing__details__current-plan__title, .payments-and-billing__details__first-billing-date__title, .payments-and-billing__details__next-billing-date__title, .payments-and-billing__details__next-billing-amount__title, .payments-and-billing__details__code__title, .payments-and-billing__details__balance__title, .payments-and-billing__details__user__title,
.referrals .payments__current-plan__title,
.referrals .payments__first-billing-date__title,
.referrals .payments__next-billing-date__title,
.referrals .payments__next-billing-amount__title,
.referrals .payments__code__title,
.referrals .payments__balance__title,
.referrals .payments__user__title,
.referrals__info__current-plan__title,
.referrals__info__first-billing-date__title,
.referrals__info__next-billing-date__title,
.referrals__info__next-billing-amount__title,
.referrals__info__code__title,
.referrals__info__balance__title,
.referrals__info__user__title,
.referrals__details__current-plan__title,
.referrals__details__first-billing-date__title,
.referrals__details__next-billing-date__title,
.referrals__details__next-billing-amount__title,
.referrals__details__code__title,
.referrals__details__balance__title,
.referrals__details__user__title {
  text-transform: uppercase;
  margin-right: 1rem;
  font-weight: 300;
}
.payments-and-billing .payments__current-plan__value, .payments-and-billing .payments__first-billing-date__value, .payments-and-billing .payments__next-billing-date__value, .payments-and-billing .payments__next-billing-amount__value, .payments-and-billing .payments__code__value, .payments-and-billing .payments__balance__value, .payments-and-billing .payments__user__value, .payments-and-billing__info__current-plan__value, .payments-and-billing__info__first-billing-date__value, .payments-and-billing__info__next-billing-date__value, .payments-and-billing__info__next-billing-amount__value, .payments-and-billing__info__code__value, .payments-and-billing__info__balance__value, .payments-and-billing__info__user__value, .payments-and-billing__details__current-plan__value, .payments-and-billing__details__first-billing-date__value, .payments-and-billing__details__next-billing-date__value, .payments-and-billing__details__next-billing-amount__value, .payments-and-billing__details__code__value, .payments-and-billing__details__balance__value, .payments-and-billing__details__user__value,
.referrals .payments__current-plan__value,
.referrals .payments__first-billing-date__value,
.referrals .payments__next-billing-date__value,
.referrals .payments__next-billing-amount__value,
.referrals .payments__code__value,
.referrals .payments__balance__value,
.referrals .payments__user__value,
.referrals__info__current-plan__value,
.referrals__info__first-billing-date__value,
.referrals__info__next-billing-date__value,
.referrals__info__next-billing-amount__value,
.referrals__info__code__value,
.referrals__info__balance__value,
.referrals__info__user__value,
.referrals__details__current-plan__value,
.referrals__details__first-billing-date__value,
.referrals__details__next-billing-date__value,
.referrals__details__next-billing-amount__value,
.referrals__details__code__value,
.referrals__details__balance__value,
.referrals__details__user__value {
  font-weight: 600;
}
.payments-and-billing .payments__next-billing-date__value, .payments-and-billing__info__next-billing-date__value, .payments-and-billing__details__next-billing-date__value,
.referrals .payments__next-billing-date__value,
.referrals__info__next-billing-date__value,
.referrals__details__next-billing-date__value {
  text-transform: uppercase;
}
.payments-and-billing .payments__user, .payments-and-billing__info__user, .payments-and-billing__details__user,
.referrals .payments__user,
.referrals__info__user,
.referrals__details__user {
  display: grid;
  grid-template-areas: "name value" "email email";
}
.payments-and-billing .payments__user__name, .payments-and-billing__info__user__name, .payments-and-billing__details__user__name,
.referrals .payments__user__name,
.referrals__info__user__name,
.referrals__details__user__name {
  grid-area: name;
}
.payments-and-billing .payments__user__value, .payments-and-billing__info__user__value, .payments-and-billing__details__user__value,
.referrals .payments__user__value,
.referrals__info__user__value,
.referrals__details__user__value {
  grid-area: value;
  text-align: right;
}
.payments-and-billing .payments__user__email, .payments-and-billing__info__user__email, .payments-and-billing__details__user__email,
.referrals .payments__user__email,
.referrals__info__user__email,
.referrals__details__user__email {
  grid-area: email;
}
.payments-and-billing .links,
.referrals .links {
  line-height: 2.5rem;
}
.payments-and-billing .links a,
.referrals .links a {
  text-transform: uppercase;
}
.payments-and-billing .payment-detail,
.payments-and-billing .update-card, .payments-and-billing__details,
.referrals .payment-detail,
.referrals .update-card,
.referrals__details {
  line-height: 2.5rem;
}
.payments-and-billing .payment-detail__heading,
.payments-and-billing .update-card__heading, .payments-and-billing__details__heading,
.referrals .payment-detail__heading,
.referrals .update-card__heading,
.referrals__details__heading {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin-bottom: 1.6rem;
}
.payments-and-billing .payment-detail__heading__label,
.payments-and-billing .update-card__heading__label, .payments-and-billing__details__heading__label,
.referrals .payment-detail__heading__label,
.referrals .update-card__heading__label,
.referrals__details__heading__label {
  text-transform: uppercase;
}
.payments-and-billing .payment-detail__charge,
.payments-and-billing .update-card__charge, .payments-and-billing__details__charge,
.referrals .payment-detail__charge,
.referrals .update-card__charge,
.referrals__details__charge {
  display: flex;
  justify-content: space-between;
}
.payments-and-billing .payment-detail__current,
.payments-and-billing .update-card__current, .payments-and-billing__details__current,
.referrals .payment-detail__current,
.referrals .update-card__current,
.referrals__details__current {
  display: flex;
  margin-bottom: 1.6rem;
}
.payments-and-billing .payment-detail__current__label, .payments-and-billing .payment-detail__current__brand,
.payments-and-billing .update-card__current__label,
.payments-and-billing .update-card__current__brand, .payments-and-billing__details__current__label, .payments-and-billing__details__current__brand,
.referrals .payment-detail__current__label,
.referrals .payment-detail__current__brand,
.referrals .update-card__current__label,
.referrals .update-card__current__brand,
.referrals__details__current__label,
.referrals__details__current__brand {
  margin-right: 1rem;
}
.payments-and-billing__details__heading,
.referrals__details__heading {
  text-decoration: underline;
  margin-bottom: 0;
}

.report-problem {
  position: relative;
}
.report-problem label,
.report-problem textarea,
.report-problem input {
  display: block;
}
.report-problem textarea {
  color: black;
  width: 100%;
}
.report-problem a {
  color: white;
  text-transform: uppercase;
}
.report-problem a:hover {
  color: white;
}
.report-problem a.gold {
  color: #dabc64;
  text-transform: none;
}
.report-problem a.gold:hover {
  color: #dabc64;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Pages/Account/MyAccount.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACE;EACE,6BAAA;EACA,WAAA;AAEJ;AADI;EAHF;IAII,aAAA;IACA,QAAA;IACA,OAAA;IACA,QAAA;IACA,WAAA;EAIJ;AACF;AAHI;EAVF;IAWI,UAAA;IACA,QAAA;IACA,SAAA;IACA,UAAA;IACA,WAAA;EAMJ;AACF;;AADE;EACE,yBAAA;AAIJ;AADE;EACE,mBAAA;AAGJ;AACI;;;;;;;EAOE,mBAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;AACN;AACM;;;;;;;EACE,0BAAA;AAOR;;AADE;EAEE,aAAA;EACA,8BAAA;EACA,iBAAA;AAGJ;AADI;EACE,yBAAA;AAGN;AACE;EACE,iBAAA;AACJ;AAEE;EACE,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AAAJ;AAEI;EACE,0BAAA;AAAN;;AAOE;;EACE,YAAA;EACA,eAAA;EACA,cAAA;AAHJ;AAKI;;EACE,YAAA;AAFN;AAME;;;;EAgDE,qBAAA;AAhDJ;AAGI;;;;;;;;;;;;;;;;;;;;;;EAOE,aAAA;EACA,mBAAA;AAcN;AAZM;;;;;;;;;;;;;;;;;;;;;;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AAmCR;AAhCM;;;;;;;;;;;;;;;;;;;;;;EACE,gBAAA;AAuDR;AAnDI;;;;EACE,yBAAA;AAwDN;AArDI;;;;EACE,aAAA;EACA,+CACE;AAyDR;AAtDM;;;;EACE,eAAA;AA2DR;AAxDM;;;;EACE,gBAAA;EACA,iBAAA;AA6DR;AA1DM;;;;EACE,gBAAA;AA+DR;AAxDE;;EACE,mBAAA;AA2DJ;AA1DI;;EACE,yBAAA;AA6DN;AAzDE;;;;;EAGE,mBAAA;AA6DJ;AA5DI;;;;;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;AAkEN;AAhEM;;;;;EACE,yBAAA;AAsER;AAlEI;;;;;EACE,aAAA;EACA,8BAAA;AAwEN;AArEI;;;;;EACE,aAAA;EACA,qBAAA;AA2EN;AAzEM;;;;;;;;;EAEE,kBAAA;AAkFR;AA5EI;;EACE,0BAAA;EACA,gBAAA;AA+EN;;AA1EA;EACE,kBAAA;AA6EF;AA3EE;;;EAGE,cAAA;AA6EJ;AA1EE;EACE,YAAA;EACA,WAAA;AA4EJ;AAzEE;EACE,YAAA;EACA,yBAAA;AA2EJ;AAzEI;EACE,YAAA;AA2EN;AAxEI;EACE,cDpMC;ECqMD,oBAAA;AA0EN;AAxEM;EACE,cDxMD;ECyMC,0BAAA;AA0ER","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import './Variables.scss';\n@import './Colors.scss';\n.react-modal-overlay.my-account-modal {\n  .react-modal {\n    /*border: 0.1rem solid #000;*/\n    color: #fff;\n    @media (min-width: $smobile) {\n      padding: 2rem;\n      top: 10%;\n      left: 0;\n      right: 0;\n      bottom: 10%;\n    }\n    @media (min-width: $hdlaptop) {\n      padding: 0;\n      top: 20%;\n      left: 25%;\n      right: 25%;\n      bottom: 20%;\n    }\n  }\n}\n\n.my-account-modal {\n  .my-account-header {\n    text-transform: uppercase;\n  }\n\n  .padding-top {\n    padding-top: 2.5rem;\n  }\n\n  .my-account-content {\n    a.faq,\n    a.report,\n    a.terms,\n    a.privacy,\n    a.delete-account,\n    a.paddle-support,\n    .referrals-link {\n      line-height: 2.5rem;\n      color: white;\n      display: block;\n      text-transform: uppercase;\n      cursor: pointer;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n}\n.tracking-status {\n  &__device,\n  &__global {\n    display: flex;\n    justify-content: space-between;\n    padding: 0.5rem 0;\n\n    &__label {\n      text-transform: uppercase;\n    }\n  }\n\n  &__actions {\n    text-align: right;\n  }\n\n  .btn.btn-default {\n    background: none;\n    color: white;\n    text-transform: uppercase;\n    border-radius: 0;\n    border: none;\n    padding: 0.5rem 0;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.payments-and-billing,\n.referrals {\n  a {\n    color: white;\n    cursor: pointer;\n    display: block;\n\n    &:hover {\n      color: white;\n    }\n  }\n\n  .payments,\n  &__info,\n  &__details {\n    &__current-plan,\n    &__first-billing-date,\n    &__next-billing-date,\n    &__next-billing-amount,\n    &__code,\n    &__balance,\n    &__user {\n      display: flex;\n      line-height: 2.5rem;\n\n      &__title {\n        text-transform: uppercase;\n        margin-right: 1rem;\n        font-weight: 300;\n      }\n\n      &__value {\n        font-weight: 600;\n      }\n    }\n\n    &__next-billing-date__value {\n      text-transform: uppercase;\n    }\n\n    &__user {\n      display: grid;\n      grid-template-areas:\n        'name value'\n        'email email';\n\n      &__name {\n        grid-area: name;\n      }\n\n      &__value {\n        grid-area: value;\n        text-align: right;\n      }\n\n      &__email {\n        grid-area: email;\n      }\n    }\n\n    margin-bottom: 1.6rem;\n  }\n\n  .links {\n    line-height: 2.5rem;\n    a {\n      text-transform: uppercase;\n    }\n  }\n\n  .payment-detail,\n  .update-card,\n  &__details {\n    line-height: 2.5rem;\n    &__heading {\n      display: flex;\n      flex-flow: row wrap;\n      justify-content: space-between;\n      margin-bottom: 1.6rem;\n\n      &__label {\n        text-transform: uppercase;\n      }\n    }\n\n    &__charge {\n      display: flex;\n      justify-content: space-between;\n    }\n\n    &__current {\n      display: flex;\n      margin-bottom: 1.6rem;\n\n      &__label,\n      &__brand {\n        margin-right: 1rem;\n      }\n    }\n  }\n\n  &__details {\n    &__heading {\n      text-decoration: underline;\n      margin-bottom: 0;\n    }\n  }\n}\n\n.report-problem {\n  position: relative;\n\n  label,\n  textarea,\n  input {\n    display: block;\n  }\n\n  textarea {\n    color: black;\n    width: 100%;\n  }\n\n  a {\n    color: white;\n    text-transform: uppercase;\n\n    &:hover {\n      color: white;\n    }\n\n    &.gold {\n      color: $gold;\n      text-transform: none;\n\n      &:hover {\n        color: $gold;\n        text-decoration: underline;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
